import { render, staticRenderFns } from "./ProcedureNew.vue?vue&type=template&id=53441d32&"
import script from "./ProcedureNew.vue?vue&type=script&lang=js&"
export * from "./ProcedureNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports